import {Injectable} from '@angular/core';
import {BreadcrumbService} from '../breadcrumb/breadcrumb.service';
import {RouteLoaderComponent} from '../../components/route-loader/route-loader.component';
import {Overlay, OverlayRef} from '@angular/cdk/overlay';
import {ComponentPortal} from '@angular/cdk/portal';
import {NavigationEnd, Router} from '@angular/router';

@Injectable()
export class BreadCrumbAndDataHelperService {

  private overlayRef?: OverlayRef;

  constructor(public breadCrumbService: BreadcrumbService,
              private overlay: Overlay,
              private router: Router) {

    router.events.subscribe((routeEvent) => {
      if (routeEvent instanceof NavigationEnd)
        this.removeLoader();
    });
  }

  /**
   * Show the full page loader
   */
  public showLoader() {
    if (this.overlayRef != null)
      return;
    this.overlayRef = this.overlay.create();
    this.overlayRef.attach(new ComponentPortal(RouteLoaderComponent));
  }

  /**
   * Remove the loader from the screen
   */
  public removeLoader() {
    if (this.overlayRef == null)
      return;
    this.overlayRef.detach();
    this.overlayRef = null;
  }


}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/utilities/services/route-resolvers/bread-crumb-and-data-helper.service.ts